import { MapTo } from '@adobe/aem-react-editable-components';
import InformationCard, { InformationCardEditConfig } from './InformationCard';

export default MapTo('cob-corp-acquisition/components/creditonebank/information-card')(InformationCard, InformationCardEditConfig);